import { ReactNode } from 'react';
import { SidebarOuter } from '@/components/sections/Sidebar/SidebarOuter';

export interface FrameProps {
  header: ReactNode;
  aside: ReactNode;
  main: ReactNode;
}

export const FrameWithSidebar = ({ header, aside, main }: FrameProps) => {
  return (
    <>
      <header className="sticky top-0 border-b border-gray-200 z-20 h-[calc(5.5rem_+_1px)] md:h-[calc(6.5rem_+_1px)]">
        {header}
      </header>
      <div className="flex flex-grow flex-col sm:flex-row-reverse">
        <main className="flex-grow bg-gray-100 pb-12 sm:pb-0 md:pl-16 max-w-full">
          {main}
        </main>
        <SidebarOuter>{aside}</SidebarOuter>
      </div>
    </>
  );
};

export default FrameWithSidebar;
